module.exports = __webpack_public_path__ + "img/rocket.7461c5ac.svg";